import React from "react";
import { StyleProp, TouchableOpacity, ViewStyle } from "react-native";
import { Feather } from "@expo/vector-icons";
import { useRouter } from "expo-router";

type Props = {
  iconColor?: string;
  style?: StyleProp<ViewStyle> | undefined;
  onPress?: () => void;
};

function BackButton({
  iconColor = "black",
  style = undefined,
  onPress,
}: Props): React.JSX.Element {
  const router = useRouter();

  const onPressHandler = (): void => {
    if (onPress) {
      onPress();
    } else {
      router.back();
    }
  };

  return (
    <TouchableOpacity
      style={style}
      hitSlop={8}
      onPress={() => onPressHandler()}
    >
      <Feather name="arrow-left" size={24} color={iconColor} />
    </TouchableOpacity>
  );
}

export default BackButton;
